import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C06AFD8C-C769-41B1-8E5C-355CE5DBEE8E
 * name trackpad
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trackpad.svg
 * tags
 */
export const TrackpadIcon = createSvgIcon(<><path d="M4,3H20A2,2 0 0,1 22,5V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V5A2,2 0 0,1 4,3M4,5V13H20V5H4M4,19H11V15H4V19M20,19V15H13V19H20Z" /></>, 'TrackpadIcon');
export default TrackpadIcon